<div class="row">
    <div class="col-xs-12">
        <div class="main-box clearfix activate-requisition-container">
            <div class="col-lg-5 activate-requisition-content">
                <h2>Set Requisition Status to <span class="emerald">'Open'</span></h2>
                <div class="onoffswitch">
                    <input type="checkbox" name="onoffswitch" [(ngModel)]="isActivateRequisitionEnabled"
                        (ngModelChange)="onActivateRequisitionSwitchChange()" [disabled]="currentJobStatus !== 'DRAFT'"
                        class="onoffswitch-checkbox" id="myonoffswitch">
                    <label class="onoffswitch-label" for="myonoffswitch">
                        <div class="onoffswitch-inner"></div>
                        <div class="onoffswitch-switch"></div>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>
